import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'
import { MagstimColor } from 'common/Magstim.Color';

function __getColor(colorError, colorWarning, ...res) {
    
    var retVal = undefined;

    for (var x = 0; x < res[0].length; x++) {

        // console.log(`colorError=${colorError} colorWarning=${colorWarning} res[${x}]=${res[x]} retVal=${retVal}`);

        if (res[0][x] === 'MSG_0432') {
            // Highest level, break now
            retVal = colorError;
            break;
        }
        else if ((res[0][x] === 'MSG_0431') && (undefined === retVal)) {
            // Warning level, remember and carry on...
            retVal = colorWarning;
        } 

    }
    
    // console.log(`colorError=${colorError} colorWarning=${colorWarning} res=${res} retVal=${retVal}`);

   return retVal;
}

export function getBackgroundColor(...res) {
    return __getColor(MagstimColor.MagstimError, MagstimColor.MagstimWarning, res);
}

export function getForegroundColor(...res) {
    return __getColor(MagstimColor.MagstimWhite, MagstimColor.MagstimBlack, res);
}

class MagstimTableDataDevice extends MagstimTableData {
    
    getNamedValuePairs(data) {

        const epvStatusBackgroundColor = getBackgroundColor(data.EpvStatusRes);
        const epvStatusForegroundColor = getForegroundColor(data.EpvStatusRes);

        const hciStatusBackgroundColor = getBackgroundColor(data.HciStatusRes);
        const hciStatusForegroundColor = getForegroundColor(data.HciStatusRes);

        const serviceDateStatusBackgroundColor = getBackgroundColor(data.ServiceStatusRes);
        const serviceDateStatusForegroundColor = getForegroundColor(data.ServiceStatusRes);

        const  tableData = [
            // Device
            { name: CurrentLang().settings_software_no, value: StringUtils.formatStringOrNoData(data.SoftwareNumber, CurrentLang().no_data) },
            { name: CurrentLang().settings_hardware_no, value: StringUtils.formatStringOrNoData(data.HardwareNumber, CurrentLang().no_data) },
            { name: CurrentLang().settings_version_no, value: StringUtils.formatStringOrNoData(data.VersionNumber, CurrentLang().no_data) },
            { name: CurrentLang().settings_revision_no, value: StringUtils.formatStringOrNoData(data.RevisionNumber, CurrentLang().no_data) },
            { name: CurrentLang().settings_serial_number, value: StringUtils.formatStringOrNoData(data.Name, CurrentLang().no_data) },
            
            { name: CurrentLang().settings_epv, value: StringUtils.formatPercentOrNoData(data.EpvPc, CurrentLang().no_data), backgroundColor: epvStatusBackgroundColor, color: epvStatusForegroundColor },
            { name: CurrentLang().settings_epv_status, value: StringUtils.formatStringOrNoData(CurrentLang()[data.EpvStatusRes], CurrentLang().no_data), backgroundColor: epvStatusBackgroundColor, color: epvStatusForegroundColor },
            
            { name: CurrentLang().setting_hci, value: StringUtils.formatPercentOrNoData(data.HciPc, CurrentLang().no_data), backgroundColor: hciStatusBackgroundColor, color: hciStatusForegroundColor },
            { name: CurrentLang().settings_hci_status, value: StringUtils.formatStringOrNoData(CurrentLang()[data.HciStatusRes], CurrentLang().no_data), backgroundColor: hciStatusBackgroundColor, color: hciStatusForegroundColor},

            { name: CurrentLang().settings_last_service, value: StringUtils.formatDateOrNoData(data.ServiceDateLast, CurrentLang().no_data) },
            { name: CurrentLang().settings_next_service, value: StringUtils.formatDateOrNoData(data.ServiceDateNext, CurrentLang().no_data), backgroundColor: serviceDateStatusBackgroundColor, color: serviceDateStatusForegroundColor },
            { name: CurrentLang().settings_service_status, value: StringUtils.formatStringOrNoData(CurrentLang()[data.ServiceStatusRes], CurrentLang().no_data), backgroundColor: serviceDateStatusBackgroundColor, color: serviceDateStatusForegroundColor },
        ]

        //console.log(`MagstimTableDataDevice.getNamedValuePairs`, tableData);

        return tableData;
    }
}

export default MagstimTableDataDevice;